let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Djx5")).then(() => parcelRequire('76mtb'));